import { useState } from 'react';

const CATEGORY_OPTIONS = ['娱乐圈', '主播网红', '品牌动向', '影视综', '科技数码', '其他'];
const DESCRIPTION_LIMIT = 500;

const REASONS = [
  { icon: 'ri-eye-line', title: '匿名提交', text: '昵称可留可不留，写不写都由你决定。' },
  { icon: 'ri-git-branch-line', title: '接得上线', text: '有效线索会挂进对应的追踪线里，后续持续更新。' },
  { icon: 'ri-shield-check-line', title: '只看事实', text: '没有来源和佐证的内容不予收录，避免误伤。' },
];

export default function SubmitSection() {
  const [nickname, setNickname] = useState('');
  const [contact, setContact] = useState('');
  const [category, setCategory] = useState(CATEGORY_OPTIONS[0]);
  const [detail, setDetail] = useState('');
  const [status, setStatus] = useState<'idle' | 'done' | 'error'>('idle');

  const handleSubmit = () => {
    if (detail.trim().length < 10) {
      setStatus('error');
      return;
    }
    setStatus('done');
  };

  return (
    <section id="submit" className="relative overflow-hidden bg-foreground-950 py-12 text-background-50 md:py-16">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20textured%20stone%20surface%20with%20scattered%20warm%20golden%20light%20streaks%20and%20deep%20red%20undertones%2C%20cinematic%20abstract%20background%2C%20editorial%20style%2C%20high%20contrast%20and%20atmospheric%20mood&width=1600&height=700&seq=hl51-submit-bg&orientation=landscape"
          alt="黑料51线索投稿区背景，暗色抽象质感"
          className="h-full w-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950 via-foreground-950/85 to-foreground-950/40" />

      <div className="relative mx-auto max-w-[1440px] px-4 md:px-8">
        <div className="grid gap-8 lg:grid-cols-2 lg:items-start lg:gap-12">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-3.5 py-1.5 font-label text-[11px] font-semibold uppercase tracking-[0.18em] text-foreground-950">
              Submit Tips
            </span>
            <h2 className="mt-5 font-heading text-2xl font-black leading-tight text-background-50 md:text-4xl">
              手里有线索？
              <br />
              丢进来，我们接着往下盯
            </h2>
            <p className="mt-4 max-w-lg text-sm leading-relaxed text-background-100/75">
              不管是刚冒头的黑料线索，还是你想补充的旧料后续，都可以从这里提交。信息越具体，越容易接上已有的追踪线。
            </p>

            <div className="mt-8 flex flex-col gap-5">
              {REASONS.map((reason) => (
                <div key={reason.title} className="flex items-start gap-4">
                  <span className="flex h-11 w-11 flex-none items-center justify-center rounded-md bg-background-50/10">
                    <i className={`${reason.icon} text-lg text-accent-400`} />
                  </span>
                  <span>
                    <span className="block font-heading text-sm font-bold text-background-50">
                      {reason.title}
                    </span>
                    <span className="mt-0.5 block text-xs leading-relaxed text-background-100/65">
                      {reason.text}
                    </span>
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-lg border border-background-50/10 bg-background-50 p-5 text-foreground-950 md:p-7">
            <div className="flex items-center justify-between border-b border-background-200 pb-4">
              <h3 className="font-heading text-base font-bold">在线投稿</h3>
              <span className="flex items-center gap-1.5 text-[11px] text-foreground-500">
                <i className="ri-lock-2-line text-sm" />
                提交前请先脱敏
              </span>
            </div>

            <div className="mt-5 grid gap-4 sm:grid-cols-2">
              <label className="flex flex-col gap-1.5">
                <span className="text-xs font-medium text-foreground-600">昵称（选填）</span>
                <input
                  type="text"
                  value={nickname}
                  onChange={(e) => setNickname(e.target.value)}
                  placeholder="怎么称呼你"
                  className="rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm outline-none transition-colors focus:border-primary-400"
                />
              </label>
              <label className="flex flex-col gap-1.5">
                <span className="text-xs font-medium text-foreground-600">联系方式（选填）</span>
                <input
                  type="text"
                  value={contact}
                  onChange={(e) => setContact(e.target.value)}
                  placeholder="邮箱或社交账号"
                  className="rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm outline-none transition-colors focus:border-primary-400"
                />
              </label>
            </div>

            <div className="mt-4 flex flex-col gap-1.5">
              <span className="text-xs font-medium text-foreground-600">线索类别</span>
              <div className="flex flex-wrap gap-2">
                {CATEGORY_OPTIONS.map((option) => (
                  <button
                    key={option}
                    type="button"
                    onClick={() => setCategory(option)}
                    className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs font-medium transition-colors ${
                      category === option
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-200 text-foreground-700 hover:bg-background-300'
                    }`}
                  >
                    {option}
                  </button>
                ))}
              </div>
            </div>

            <div className="mt-4 flex flex-col gap-1.5">
              <div className="flex items-center justify-between">
                <span className="text-xs font-medium text-foreground-600">线索描述</span>
                <span className="font-label text-[11px] text-foreground-400">
                  {detail.length} / {DESCRIPTION_LIMIT}
                </span>
              </div>
              <textarea
                value={detail}
                onChange={(e) => {
                  setDetail(e.target.value.slice(0, DESCRIPTION_LIMIT));
                  if (status !== 'idle') setStatus('idle');
                }}
                maxLength={DESCRIPTION_LIMIT}
                rows={4}
                placeholder="时间、地点、涉及的账号或品牌、你看到的原话，写得越清楚越好"
                className="resize-none rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm leading-relaxed outline-none transition-colors focus:border-primary-400"
              />
            </div>

            {status === 'error' && (
              <p className="mt-3 rounded-md bg-primary-50 px-3 py-2 text-xs text-primary-700">
                线索描述至少写 10 个字，方便我们核对与跟进。
              </p>
            )}
            {status === 'done' && (
              <p className="mt-3 flex items-center gap-2 rounded-md bg-secondary-100 px-3 py-2 text-xs text-secondary-800">
                <i className="ri-checkbox-circle-fill text-sm" />
                已收到你的线索（演示状态，暂不会真实提交），我们会顺着这条线继续盯。
              </p>
            )}

            <div className="mt-5 flex flex-wrap items-center gap-3">
              <button
                type="button"
                onClick={handleSubmit}
                className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                提交线索
              </button>
              <button
                type="button"
                onClick={() => {
                  setNickname('');
                  setContact('');
                  setDetail('');
                  setCategory(CATEGORY_OPTIONS[0]);
                  setStatus('idle');
                }}
                className="whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100"
              >
                清空
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}